import StockShow from './StockShow'
export {StockShow}
export default StockShow
